import {AbstractStorage} from "../../../services/storage/abstract-storage";
import {LocalStorageService} from "../../../services/storage/local-storage";

export default class CourseSectionViewState {
  private isOpen: boolean;
  private storageService: AbstractStorage;
  private readonly localStorageKey: string;
  private readonly sectionNumber: number;

  constructor(courseId: number, sectionNumber: number, storageService = new LocalStorageService()) {
    this.storageService = storageService;
    this.sectionNumber = sectionNumber;
    this.localStorageKey = `course_${courseId}_section_${sectionNumber}`;
    this.loadStateFromLocalStorage();
  }

  public isSectionOpen(): boolean {
    return this.isOpen;
  }

  public onSectionStateChange(isOpen: boolean) {
    const hasStateChanged = isOpen != this.isOpen;
    if (hasStateChanged) {
      isOpen ? this.markOpen() : this.markClosed();
    }
  }

  private markOpen(): void {
    this.updateStateAndSaveChangesToLocalStorage(true);
  }

  private markClosed(): void {
    this.updateStateAndSaveChangesToLocalStorage(false);
  }

  private loadStateFromLocalStorage() {
    const storedState = this.storageService.getJsonItem<boolean>(this.localStorageKey);

    if (storedState !== undefined) {
      this.updateState(storedState);
    } else {
      this.updateState(this.sectionNumber === 1);
    }
  }

  private updateStateAndSaveChangesToLocalStorage(isOpen: boolean): void {
    this.updateState(isOpen);
    this.saveToLocalStorage();
  }

  private updateState(newState: boolean) {
    this.isOpen = newState;
  }

  private saveToLocalStorage(): void {
    this.storageService?.setItem<string>(this.localStorageKey, JSON.stringify(this.isOpen));
  }
}